import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, forkJoin } from 'rxjs';
import { Constants } from '../constants/constants';
import { HttpClient, HttpHeaders, HttpResponse, HttpParams } from '@angular/common/http';
import { UtilService } from '../service/util.service';
import { AuthenticationService } from './authentication.service';
import { ContactUsModel } from '../contact-us/contact-us.component';
import { EnvService } from './env.service';

@Injectable({
	providedIn: 'root'
})
export class ApiService {

	private SERVICEPACKAGE: string = "servicepackage";
	private SEPARATOR: string = "/";
	private ACCOUNTS: string = "accounts";
	private SERVICE: string = "service";
	private PACKAGE: string = "package";
	private LOCATIONMANAGEMENT: string = "locationmanagement";
	private LOCATIONS: string = "locations";
	private OEM: string = "oem";
	private DOMAINS: string = "domains";
	private POLICY: string = "policy";
	private USERS: string = "users";
	private LIST: string = "list";
	private API: string = "api";
	private APIKEY: string = "apikey";
	private USAGE: string = "usage";
	private VEHICLES: string = "vehicles";
	private ROUTEAPI: string = "routeapi";
	private ROUTES: string = "routes";
	private MONITOR: string = "monitor";
	private ALERTS: string = "alerts";
	private TELEMATICS: string = "telematics";
	private LOCATION: string = "location";
	private DATE: string = "date"
	private REPORTS: string = "reports";
	private IMPORT: string = "import";
	private CONNECTOR: string = "connector";
	private DETAIL: string = "detail";
	private STREAMING: string = "streamingconsumer/";
	private JOURNEY: string = "journey/";
	private POLLING: string = "polling";
	private TNC: string = "tnc";
	private ACCEPT: string = "accept";
	private USER: string = "user";
	private BRAND: String = "brand";
	private BRANDS: String = "brands";
	private ROLES: string = "roles";
	private DISABLE: string = "disable";
	private ENABLE: string = "enable";
	private PROVISIONING: string = "provisioning";
	private VIN: string = "vin";
	private LIMIT: string = "limit/";
	private PASSWORD: string = "/password";
	private RESET: string = "/reset";
	private SETTINGS: string = "settings";
	private RESEND: string = "/resend";
	private INVITE: string = "/invite";
	private CUSTOMERS: string = "/customers";
	private DRIVER: string = "/driver";
	private BILLING: string = "/billing";
	private PROFILE: string = "/profile";
	private STATE: string = "/state";
	private DEVICES: string = "/devices";
	private DEVICE: string = "/device";
	private UDRSERVICE: string = "udrservice/";
	private UDR: string = "/udr";
	private FILTER: string = "/filter";
	private PROVIDERS: string = "/providers";
	private ADDRESS: string = "/address";
	private CONTACT_US: string = "contactus";
	private APP: string = "app";
	private USER_TERMS_CONDITIONS_PROFILE: string = "user-terms-conditions-profile";
	private B2C = "b2c";
	private PACKAGES: string = "/packages";
	private SUPPORTED: string = "supported";
	private LANGUAGES: string = "languages";
	private PREFERENCES: string = "preferences";
	private ZIPCODES: string = "zipcodes";
	private DATA: string = "data";
	public accountServicePackageList: any = [];
	public accountFleetLocationList: any = [];
	public accountDomainList: Array<string> = new Array();
	public adminList: any = [];
	public accountDetail: any = null;
	public usStateList: Array<string> = new Array();
	public stateList: Array<string> = new Array();

	constructor(private http: HttpClient, private authService: AuthenticationService, private env: EnvService) {
		console.log("apiService constructor");
		this.accountServicePackageList = [];
		this.accountFleetLocationList = [];
		this.accountDomainList = new Array();
		this.adminList = [];
		this.accountDetail = null;
		this.usStateList = new Array();
	}

	uploadFleetLogo(image): Promise<any> {
		var url = this.env.BASE_URL + "/uploads/images";
		var httpOption = {
			headers: new HttpHeaders({
				// 'Content-Type': 'multipart/form-data',
				'Authorization': 'Bearer ' + this.authService.authenticationModel.idToken,
				'API_KEY': Constants.API_KEY,
				'APP_TYPE': this.env.APP_TYPE
			})
		};

		return new Promise((resolve, reject) => {
			this.http.post(url, image, httpOption).subscribe((data) => {
				let res = JSON.parse(JSON.stringify(data));
				resolve(res);
			},
				error => {
					console.log(error);
					reject(error);
				});
		});
	}

	assignBillingToAccount(payload): Promise<any> {

		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR +
			this.authService.loggedInUser.enterpriseId + Constants.SEPARATOR + this.ACCOUNTS +
			this.SEPARATOR + this.authService.loggedInUser.accountId + this.BILLING + this.PROFILE;

		return new Promise((resolve, reject) => {
			this.http.put(url, payload, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getBillingProfile(): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR +
			this.authService.loggedInUser.enterpriseId + Constants.SEPARATOR + this.ACCOUNTS +
			this.SEPARATOR + this.authService.loggedInUser.accountId + this.BILLING + this.PROFILE;
		return this.executeGET(url);
	}

	updateBillingAddress(payload: any): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR +
			this.authService.loggedInUser.enterpriseId + Constants.SEPARATOR + this.ACCOUNTS +
			this.SEPARATOR + this.authService.loggedInUser.accountId + this.BILLING + this.ADDRESS;
		return this.executePUT(url, payload, this.authService.httpOption);
	}

	getAccountServicePackageList(): Promise<any> {
		var url = this.env.BASE_URL + this.SERVICEPACKAGE + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.SERVICE +
			this.SEPARATOR + this.PACKAGE;

		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				this.accountServicePackageList = data;
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getFleetLocationList(): Promise<any> {
		var url = this.env.BASE_URL + this.LOCATIONMANAGEMENT + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.LOCATIONS;

		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				this.accountFleetLocationList = res;
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getUsStateList(): Promise<any> {
		var url = this.env.BASE_URL + this.LOCATIONMANAGEMENT + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.STATE +
			this.SEPARATOR + "US";

		return new Promise((resolve, reject) => {
			if (this.usStateList != null && this.usStateList.length > 0) {
				resolve(this.usStateList);
			} else {
				this.http.get(url, this.authService.httpOption).subscribe((data) => {
					var res = JSON.parse(JSON.stringify(data));
					resolve(res);
					this.usStateList = res;
				},
					error => { reject(error); });
			}
		});
	}

	getStateList(countryCode): Promise<any> {
	  var url = this.env.BASE_URL + this.LOCATIONMANAGEMENT + this.SEPARATOR +
		this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.STATE +
		this.SEPARATOR + countryCode;
  
	  return new Promise((resolve, reject) => {
		this.http.get(url, this.authService.httpOption).subscribe((data) => {
		  var res = JSON.parse(JSON.stringify(data));
		  console.log("response : ", res);
		  resolve(res);
		},
		  error => { reject(error); });
	  });
	}
	
	/* getStateList(countryCode): Promise<any> {
		var url = this.env.BASE_URL + this.LOCATIONMANAGEMENT + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.STATE +
			this.SEPARATOR + this.DATA + this.SEPARATOR + countryCode;


		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				this.stateList = res;
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	} */

	deleteFleetLocationList(locations): Promise<any> {
		var url = this.env.BASE_URL + this.LOCATIONMANAGEMENT + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.LOCATIONS;

		return new Promise((resolve, reject) => {
			this.http.put(url, locations, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("delete location response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getLocationSettings(): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR +
			this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR +
			this.authService.loggedInUser.accountId + this.SEPARATOR + this.LOCATION + this.SEPARATOR +
			this.SETTINGS;

		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("Get location setting response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	updateLocationSettings(requestData): Promise<any> {

		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR +
			this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR +
			this.authService.loggedInUser.accountId + this.SEPARATOR + this.LOCATION + this.SEPARATOR +
			this.SETTINGS;

		return new Promise((resolve, reject) => {
			this.http.put(url, requestData, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("update location settings response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getZipCodeDetails(zipCode): Promise<any> {
		var url = "https://api.zippopotam.us/us/" + zipCode;

		return new Promise((resolve, reject) => {
			this.http.get(url).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	geZipCodeDetailsByCountry(zipCode, countryCode): Promise<any> {
		var url = this.env.BASE_URL + this.LOCATIONMANAGEMENT + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ZIPCODES + this.SEPARATOR + countryCode + this.SEPARATOR + zipCode;

		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}	

	addLocation(payload): Promise<any> {
		var url = this.env.BASE_URL + this.LOCATIONMANAGEMENT + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.LOCATIONS;

		return new Promise((resolve, reject) => {
			this.http.post(url, payload, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	updateLocation(locationId, payload): Promise<any> {
		var url = this.env.BASE_URL + this.LOCATIONMANAGEMENT + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR +
			this.LOCATIONS + this.SEPARATOR + locationId;

		return new Promise((resolve, reject) => {
			this.http.put(url, payload, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getAccountDomainList(): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.DOMAINS;

		return new Promise((resolve, reject) => {
			if (this.accountDomainList != null && this.accountDomainList.length > 0) {
				console.log("Domain list already available::", this.accountDomainList);
				resolve(this.accountDomainList);
			} else {
				this.http.get(url, this.authService.httpOption).subscribe((data) => {
					var res = JSON.parse(JSON.stringify(data));
					console.log("response : ", res);
					this.accountDomainList = res;
					resolve(res);
				},
					error => { reject(error); });
			}
		});
	}

	saveAccountDomainList(payload): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.DOMAINS;

		return new Promise((resolve, reject) => {
			this.http.post(url, payload, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				this.accountDomainList = res;
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getPolicy(): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.POLICY;

		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	updatePolicy(payload): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.POLICY;

		return new Promise((resolve, reject) => {
			this.http.put(url, payload, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getUsersByRole(payload): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.USERS + this.SEPARATOR + this.LIST;

		return new Promise((resolve, reject) => {
			this.http.post(url, payload, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getAllUsers(): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.USERS + this.SEPARATOR + this.LIST;

		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	addUsersByRole(payload): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.USERS;

		return new Promise((resolve, reject) => {
			this.http.post(url, payload, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getRoles(request): Promise<any> {

		var url = this.env.BASE_URL + Constants.API + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId +
			this.SEPARATOR + this.USER + this.SEPARATOR + this.ROLES;

		return new Promise((resolve, reject) => {
			this.http.post(url, request, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	deactivateAccountUser(userId): Promise<any> {

		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId +
			this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.USERS + this.SEPARATOR + userId + this.SEPARATOR + this.DISABLE;

		return new Promise((resolve, reject) => {
			this.http.put(url, null, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	activateAccountUser(userId): Promise<any> {

		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId +
			this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.USERS + this.SEPARATOR + userId + this.SEPARATOR + this.ENABLE;

		return new Promise((resolve, reject) => {
			this.http.put(url, null, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	resetAccountUserPassword(userId): Promise<any> {

		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId +
			this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.USERS + this.SEPARATOR + userId +
			this.PASSWORD + this.RESET;

		return new Promise((resolve, reject) => {
			this.http.put(url, null, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	resendUserInvite(userId): Promise<any> {

		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId +
			this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId +
			this.SEPARATOR + this.USERS + this.SEPARATOR + userId + this.RESEND + this.INVITE;

		return new Promise((resolve, reject) => {
			this.http.put(url, null, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	updateUserProfile(payload, userId): Promise<any> {
		var accountType = this.authService.isDongleProvider() ? this.PROVIDERS : this.SEPARATOR + this.ACCOUNTS;
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR +
			this.authService.loggedInUser.enterpriseId + accountType + this.SEPARATOR +
			this.authService.loggedInUser.accountId + this.SEPARATOR + this.USERS + this.SEPARATOR + userId;
		return new Promise((resolve, reject) => {
			this.http.put(url, payload, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	deleteAccountUser(userId): Promise<any> {

		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId +
			this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.USERS + this.SEPARATOR + userId;

		return new Promise((resolve, reject) => {
			this.http.delete(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}


	getAccountDetail(): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId;

		return new Promise((resolve, reject) => {
			// if (this.accountDetail != null && Object.keys(this.accountDetail).length !== 0) {
			if (this.accountDetail != null && this.accountDetail != {}) {
				console.log("account detail is available::", this.accountDetail);
				resolve(this.accountDetail);
			} else {
				this.http.get(url, this.authService.httpOption).subscribe((data) => {
					var res = JSON.parse(JSON.stringify(data));
					console.log("response : ", res);
					resolve(res);
					this.accountDetail = res;
				},
					error => { reject(error); });
			}
		});
	}

	updateAccountDetail(payload): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId +
			this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId;

		return new Promise((resolve, reject) => {
			this.http.put(url, payload, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getApiKey(): Promise<any> {
		var url = this.env.BASE_URL + this.API + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.APIKEY;

		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	resetApiKey(apiKey: string): Promise<any> {
		var url = this.env.BASE_URL + this.API + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.APIKEY + this.SEPARATOR + apiKey;

		return new Promise((resolve, reject) => {
			this.http.put(url, {}, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getServiceUsageForAccount(): Promise<any> {
		var url = this.env.BASE_URL + this.API + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.SERVICE + this.SEPARATOR + this.USAGE;

		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getServiceUsageDataByService(serviceName: string): Promise<any> {
		var url = this.env.BASE_URL + this.API + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.SERVICE + this.SEPARATOR + this.USAGE + this.SEPARATOR + serviceName;

		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getVehicleAtLocation(locationId: string): Promise<any> {
		var url = this.env.BASE_URL + this.LOCATIONMANAGEMENT + this.SEPARATOR + this.OEM + this.SEPARATOR +
			this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS +
			this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR +
			this.LOCATIONS + this.SEPARATOR + locationId + this.SEPARATOR + this.VEHICLES;

		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	addVehicle(payload): Promise<any> {
		var url = this.env.BASE_URL + Constants.PROVISIONING_URL + this.PROVISIONING;
		console.log("payload : ", payload);
		return new Promise((resolve, reject) => {
			this.http.post(url, payload, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getAccountVehicles(accountId): Promise<any> {

		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR +
			this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR +
			accountId + this.SEPARATOR + this.VEHICLES;

		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("Account vehicles api response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getPaginatedAccountVehicles(payload, page, size): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR +
			this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR +
			this.authService.loggedInUser.accountId + this.SEPARATOR + this.VEHICLES + Constants.PAGINATED + Constants.FILTERS + encodeURIComponent("?page=" + page + "&pageSize=" + size);

		return this.executePOST(url, payload, this.authService.httpOption);
	}

	updateVehicleMapingFromAccount(payload): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR +
			this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR
			+ this.authService.loggedInUser.accountId + this.SEPARATOR + this.VEHICLES;
		return this.executePOST(url, payload, this.authService.httpOption);
	}

	getVehiclesServicePackages(accountId: string, vin: string): Promise<any> {
		var url = this.env.BASE_URL + this.SERVICEPACKAGE + this.SEPARATOR + this.OEM + this.SEPARATOR +
			this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + accountId +
			this.SEPARATOR + this.VEHICLES + this.SEPARATOR + vin + this.SEPARATOR + this.SERVICE + this.SEPARATOR + this.PACKAGE;

		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getVehiclesLocation(accountId: string, vin: string): Promise<any> {
		var url = this.env.BASE_URL + this.LOCATIONMANAGEMENT + this.SEPARATOR + this.OEM + this.SEPARATOR +
			this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + accountId +
			this.SEPARATOR + this.LOCATIONS + this.SEPARATOR + this.VEHICLES + this.SEPARATOR + vin;
		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getVehiclesPackageLocationInfo(accountId: string, vin: string): Observable<any[]> {
		var servicePackageUrl = this.env.BASE_URL + this.SERVICEPACKAGE + this.SEPARATOR + this.OEM + this.SEPARATOR +
			this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + accountId +
			this.SEPARATOR + this.VEHICLES + this.SEPARATOR + vin + this.SEPARATOR + this.SERVICE + this.SEPARATOR + this.PACKAGE;

		var locationUrl = this.env.BASE_URL + this.LOCATIONMANAGEMENT + this.OEM + this.SEPARATOR +
			this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + accountId +
			this.SEPARATOR + this.LOCATIONS + this.SEPARATOR + this.VEHICLES + this.SEPARATOR + vin;

		let servicePackageResponse = this.http.get(servicePackageUrl, this.authService.httpOption);
		let locationResponse = this.http.get(locationUrl, this.authService.httpOption);
		return forkJoin([servicePackageResponse, locationResponse]);
	}

	addVehicleDevice(payload, vin): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR +
			this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR
			+ this.authService.loggedInUser.accountId + this.SEPARATOR + this.VEHICLES + this.SEPARATOR + vin + this.DEVICES;
		return new Promise((resolve, reject) => {
			this.http.post(url, payload, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	updateVehicleDevice(payload, vin, deviceId): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR +
			this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR
			+ this.authService.loggedInUser.accountId + this.SEPARATOR + this.VEHICLES + this.SEPARATOR + vin + this.DEVICES + this.SEPARATOR +
			deviceId;
		return new Promise((resolve, reject) => {
			this.http.put(url, payload, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getVehicleDetails(vin): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR +
			this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR
			+ this.authService.loggedInUser.accountId + this.SEPARATOR + this.VEHICLES + this.SEPARATOR + vin;

		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	unlinkVehicleDevice(vin, deviceId): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR +
			this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR
			+ this.authService.loggedInUser.accountId + this.SEPARATOR + this.VEHICLES + this.SEPARATOR + vin + this.DEVICES + this.SEPARATOR +
			deviceId;
		return new Promise((resolve, reject) => {
			this.http.delete(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	setupRouteForLocation(payload: any): Promise<any> {
		var url = this.env.BASE_URL + this.ROUTEAPI + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.ROUTES;

		return new Promise((resolve, reject) => {
			this.http.post(url, payload, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("Setup route response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getRouteForLocation(locationId: string, date): Promise<any> {
		var url = this.env.BASE_URL + this.ROUTEAPI + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.ROUTES +
			this.SEPARATOR + locationId + this.SEPARATOR + date;

		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("get route for location response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getAlerts(vin: string): Promise<any> {
		var url = this.env.BASE_URL + this.MONITOR + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.VEHICLES +
			this.SEPARATOR + vin + this.SEPARATOR + this.ALERTS;

		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	executeTelematicService(payload: any): Promise<any> {
		var url = this.env.BASE_URL + this.TELEMATICS + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.LOCATION;

		return new Promise((resolve, reject) => {
			this.http.post(url, payload, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("temematics response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	executeGET(url: string): Promise<any> {
		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	executePOST(url: string, payload = {}, options): Promise<any> {
		console.log("payload::", payload, ":: http Options::", options);
		return new Promise((resolve, reject) => {
			this.http.post(url, payload, options).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	executePUT(url: string, payload = {}, options): Promise<any> {
		console.log("payload::", payload, ":: http Options::", options);
		return new Promise((resolve, reject) => {
			this.http.put(url, payload, options).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	executeDELETE(url: string): Promise<any> {
		return new Promise((resolve, reject) => {
			this.http.delete(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getServiceUsageByDate(): Promise<any> {
		var url = this.env.BASE_URL + this.API + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.SERVICE +
			this.SEPARATOR + this.USAGE + this.SEPARATOR + this.DATE;

		return this.executeGET(url);
	}

	getSErviceUsageForDate(date): Promise<any> {
		var url = this.env.BASE_URL + this.API + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.SERVICE +
			this.SEPARATOR + this.USAGE + this.SEPARATOR + this.DATE + this.SEPARATOR + date;

		return this.executeGET(url);
	}

	getDateWiseServiceUsageBetweenDates(fromDate, toDate): Promise<any> {
		var url = this.env.BASE_URL + this.API + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.SERVICE +
			this.SEPARATOR + this.USAGE + this.SEPARATOR + this.DATE + this.SEPARATOR + fromDate + this.SEPARATOR + toDate;

		return this.executeGET(url);
	}

	getServiceUsageReportsBetweenDates(fromDate, toDate): Promise<any> {
		var url = this.env.BASE_URL + this.REPORTS + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId +
			this.SEPARATOR + this.USAGE + this.SEPARATOR + this.DATE + this.SEPARATOR + fromDate + this.SEPARATOR + toDate;

		return this.executeGET(url);
	}

	getServiceUsageByServiceNameBetweenDate(fromDate, toDate): Promise<any> {
		var url = this.env.BASE_URL + this.API + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.SERVICE + this.SEPARATOR + this.USAGE +
			this.SEPARATOR + fromDate + this.SEPARATOR + toDate;

		return this.executeGET(url);
	}

	getServiceUsageReportsWithPageSize(accountId, fromDate, toDate, size): Promise<any> {
		var url = this.env.BASE_URL + this.REPORTS + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId +
			this.SEPARATOR + this.USAGE + this.SEPARATOR + this.DATE + this.SEPARATOR + fromDate + this.SEPARATOR + toDate +
			this.SEPARATOR + this.LIMIT + size;

		return this.executeGET(url);
	}

	getServiceUsageReportsbyPageIndex(accountId, fromDate, toDate, size, page, index): Promise<any> {
		var url = this.env.BASE_URL + this.REPORTS + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId +
			this.SEPARATOR + this.USAGE + this.SEPARATOR + this.DATE + this.SEPARATOR + fromDate + this.SEPARATOR + toDate +
			this.SEPARATOR + page + this.SEPARATOR + index + this.SEPARATOR + this.LIMIT + size;

		return this.executeGET(url);
	}


	getAccountPackageLocationDetail(): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.DETAIL;

		return this.executeGET(url);
	}

	getTncForAccount(): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.TNC;

		return this.executeGET(url);
	}

	acceptTnC(payload: any): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.TNC + this.SEPARATOR + this.ACCEPT;

		return new Promise((resolve, reject) => {
			this.http.put(url, payload, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getStreamingData(): Promise<any> {
		var url = this.env.BASE_URL + this.STREAMING + this.JOURNEY + this.POLLING;

		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	uploadCsvFile(requestFile: FormData): Promise<any> {
		var url = this.env.BASE_URL + this.CONNECTOR + this.SEPARATOR + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + "/fleet/import";

		var httpOption = {
			headers: new HttpHeaders({
				'Authorization': 'Bearer ' + this.authService.authenticationModel.idToken,
				'API_KEY': Constants.API_KEY,
				'APP_TYPE': this.env.APP_TYPE
			})
		};
		return new Promise((resolve, reject) => {
			this.http.post(url, requestFile, httpOption).subscribe((data) => {
				console.log("upload response::", data);
				let res = JSON.parse(JSON.stringify(data));
				console.log("upload response JSON::", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	uploadCsv(requestFile: FormData): Promise<any> {
		var url = this.env.BASE_URL + this.CONNECTOR + this.SEPARATOR + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + "/fleet/import";

		var httpOption = {
			headers: new HttpHeaders({
				'Authorization': 'Bearer ' + this.authService.authenticationModel.idToken,
				'API_KEY': Constants.API_KEY,
				'APP_TYPE': this.env.APP_TYPE
			})
		};
		return new Promise((resolve, reject) => {
			this.http.post(url, requestFile, httpOption).subscribe((data) => {
				console.log("upload response::", data);
				let res = JSON.parse(JSON.stringify(data));
				console.log("upload response JSON::", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	updateUserRole(payload, userId): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId +
			this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.USERS + this.SEPARATOR + userId +
			this.SEPARATOR + this.ROLES;

		return new Promise((resolve, reject) => {
			this.http.put(url, payload, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	reset() {
		this.accountServicePackageList = [];
		this.accountFleetLocationList = [];
		this.accountDomainList = new Array();
		this.adminList = [];
		this.accountDetail = null;
	}

	// Dealers API

	addCustomers(payload): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.CUSTOMERS;

		return new Promise((resolve, reject) => {
			this.http.post(url, payload, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	addDrivers(payload, vin): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL +
			this.OEM + this.SEPARATOR + this.SEPARATOR + this.authService.loggedInUser.enterpriseId +
			this.SEPARATOR + this.VEHICLES + this.SEPARATOR + vin + this.DRIVER;

		return new Promise((resolve, reject) => {
			this.http.post(url, payload, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getAccountCustomers(): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.CUSTOMERS;

		return this.executeGET(url);
	}

	searchData(payload): Promise<any> {
		var url = this.env.BASE_URL + Constants.SEARCHSERVICE + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + Constants.SEARCH;

		return this.executePOST(url, payload, this.authService.httpOption);
	}

	getUDR(payload: any): Promise<any> {
		var url = this.env.BASE_URL + this.UDRSERVICE + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.UDR;
		return this.executePOST(url, payload, this.authService.httpOption);
	}

	// getRemoteServices(payload: any, accountId: string, page: number, pageSize: number): Promise<any> {
	getRemoteServices(payload: any, page: number, pageSize: number): Promise<any> {
		var url = this.env.BASE_URL + this.UDRSERVICE + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.UDR + this.FILTER + "?page=" + page + "&pageSize=" + pageSize;
		return this.executePOST(url, payload, this.authService.httpOption);
	}

	getBillingCycles() {
		var url = this.env.BASE_URL + Constants.BILLING + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + "/billing/cycles";
		return this.executeGET(url);
	}

	getAccountCharges(payload: any): Promise<any> {
		var url = this.env.BASE_URL + Constants.CHARGING + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + "/charging";
		return this.executePOST(url, payload, this.authService.httpOption);
	}

	getChargesForBillingCycle(payload: any): Promise<any> {
		var url = this.env.BASE_URL + Constants.BILLING + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + "/charge";
		return this.executePOST(url, payload, this.authService.httpOption);
	}

	// Dongle Provider api

	provision(payload): Promise<any> {
		var url = this.env.BASE_URL + Constants.PROVISIONING_URL + this.PROVISIONING;
		return this.executePOST(url, payload, this.authService.httpOption);
	}

	getDongleProviderDetail() {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.PROVIDERS + this.SEPARATOR + this.authService.loggedInUser.accountId;

		return new Promise((resolve, reject) => {
			if (this.accountDetail != null && this.accountDetail != {}) {
				resolve(this.accountDetail);
			} else {
				this.http.get(url, this.authService.httpOption).subscribe((data) => {
					var res = JSON.parse(JSON.stringify(data));
					resolve(res);
					this.accountDetail = res;
				},
					error => { reject(error); });
			}
		});
	}

	updateDeviceProviderAccount(payload): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.PROVIDERS + this.SEPARATOR + this.authService.loggedInUser.accountId;
		return this.executePUT(url, payload, this.authService.httpOption);
	}

	addDongleProvider(payload: any) {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.PROVIDERS;
		return this.executePOST(url, payload, this.authService.httpOption);
	}

	inviteDongleProviderUser(payload: any) {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.PROVIDERS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.USERS;
		return this.executePOST(url, payload, this.authService.httpOption);

	}

	getDongleProviderUser() {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.PROVIDERS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.USERS;
		return this.executeGET(url);
	}

	deleteDongleProviderUser(userId): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId +
			this.SEPARATOR + this.PROVIDERS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.USERS + this.SEPARATOR + userId;
		return this.executeDELETE(url);
	}

	deactivateDongleProviderUser(userId): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId +
			this.PROVIDERS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.USERS + this.SEPARATOR + userId + this.SEPARATOR + this.DISABLE;
		return this.executePUT(url, null, this.authService.httpOption);
	}

	activateDongleProviderUser(userId): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId +
			this.PROVIDERS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.USERS + this.SEPARATOR + userId + this.SEPARATOR + this.ENABLE;
		return this.executePUT(url, null, this.authService.httpOption);
	}

	resendDongleProviderUserInvite(userId): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId +
			this.PROVIDERS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.USERS + this.SEPARATOR + userId + this.RESEND + this.INVITE;
		return this.executePUT(url, null, this.authService.httpOption);
	}

	resetDongleProviderUserPassword(userId): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId +
			this.PROVIDERS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.USERS + this.SEPARATOR + userId + this.PASSWORD + this.RESET;
		return this.executePUT(url, null, this.authService.httpOption);
	}

	updateDongleProviderRoles(userId, payload): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId +
			this.PROVIDERS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.USERS + this.SEPARATOR + userId + this.SEPARATOR + this.ROLES;
		return this.executePUT(url, payload, this.authService.httpOption);
	}

	getDeviceProviderDevices(): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.PROVIDERS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.DEVICES;
		return this.executeGET(url);
	}

	deleteProviderDevices(payload): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.PROVIDERS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.DEVICES;
		return this.executePUT(url, payload, this.authService.httpOption);
	}

	getInvoice(payload: any): Promise<any> {
		var url = this.env.BASE_URL + Constants.BILLING + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + "/invoices";

		return this.executePOST(url, payload, this.authService.httpOption);
	}

	getInvoices(): Promise<any> {
		var url = this.env.BASE_URL + Constants.BILLING + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + "/invoices";
		return this.executeGET(url);
	}

	invoicePayment(payload: any): Promise<any> {
		var url = this.env.BASE_URL + Constants.BILLING + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + "/payments";

		return this.executePOST(url, payload, this.authService.httpOption);
	}

	getAccountPaymentSetting() {
		var url = this.env.BASE_URL + Constants.BILLING + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + "/payments/setting";
		return this.executeGET(url);
	}

	deletePaymentInstrument(instrumentId) {
		var url = this.env.BASE_URL + Constants.BILLING + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + "/payments/instruments/" + instrumentId;
		return this.executeDELETE(url);
	}

	updateAccountPaymentSetting(payload: any) {
		var url = this.env.BASE_URL + Constants.BILLING + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + "/payments/setting";
		return this.executePUT(url, payload, this.authService.httpOption);
	}

	payUsingSavedInstrument(payload: any): Promise<any> {
		var url = this.env.BASE_URL + Constants.BILLING + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + "/payments/instrument";
		return this.executePOST(url, payload, this.authService.httpOption);
	}

	getTransactions(invoiceId: string) {
		var url = this.env.BASE_URL + Constants.BILLING + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + "/invoices/" + invoiceId + "/transactions";
		return this.executeGET(url);
	}

	contactUs(payload: ContactUsModel): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.CONTACT_US;
		return this.executePOST(url, payload, this.authService.httpOption);
	}

	getSwaggerResources(): Promise<any> {
		var url = this.env.BASE_URL + this.env.PORTAL + Constants.SWAGGER_RESOURCES;
		return this.executeGET(url);
	}

	getSwaggerResourceData(url: string): Promise<any> {
		return this.executeGET(url);
	}

	// Certificates

	getCertificates() {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + Constants.SUBGROUPS;
		return this.executeGET(url);
	}

	getCertificateDetail(parentAccountId: string, subGroupId: string): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR +
			this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR +
			parentAccountId + Constants.SUBGROUPS + this.SEPARATOR + subGroupId;
		return this.executeGET(url);
	}

	getWebNotifications(): Promise<any> {
		var url = this.env.BASE_URL + Constants.NOTIFICATION_URL + Constants.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + Constants.USERS + Constants.NOTIFICATIONS;
		return this.executeGET(url);
	}

	getWebNotificationsByStatus(status: string): Promise<any> {
		var url = this.env.BASE_URL + Constants.NOTIFICATION_URL + Constants.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + Constants.USERS + Constants.NOTIFICATIONS + this.SEPARATOR + status;
		return this.executeGET(url);
	}

	updateWebNotification(requestPayload): Promise<any> {
		var url = this.env.BASE_URL + Constants.NOTIFICATION_URL + Constants.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + Constants.USERS + Constants.NOTIFICATIONS;
		return this.executePUT(url, requestPayload, this.authService.httpOption);
	}

	updateWebNotificationActionStatus(requestPayload): Promise<any> {
		var url = this.env.BASE_URL + Constants.NOTIFICATION_URL + Constants.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + Constants.USERS + Constants.NOTIFICATIONS + Constants.ACTIONS;
		return this.executePUT(url, requestPayload, this.authService.httpOption);
	}

	getClientIpAddress(): Promise<any> {
		return this.executeGET(Constants.IPADDRESS_CHECK_URL);
	}

	defleetVehicles(requestPayload): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.VEHICLES + Constants.DEFLEET;
		return this.executePUT(url, requestPayload, this.authService.httpOption);
	}

	enrollVehicles(requestPayload): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.VEHICLES + Constants.ENROLL;
		return this.executePUT(url, requestPayload, this.authService.httpOption);
	}

	unenrollVehicles(requestPayload): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.VEHICLES + Constants.UNENROLL;
		return this.executePUT(url, requestPayload, this.authService.httpOption);
	}

	unenrollStatusData(requestPayload): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.VEHICLES + Constants.UNENROLLMENT + Constants.DATA;
		return this.executePOST(url, requestPayload, this.authService.httpOption);
	}

	enrollStatusData(requestPayload): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.VEHICLES + Constants.ENROLLMENT + Constants.DATA;
		return this.executePOST(url, requestPayload, this.authService.httpOption);
	}

	getUserTnc(appType): Promise<any> {

		var url = this.env.BASE_URL + Constants.ONBOARDING_URL +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.USER_TERMS_CONDITIONS_PROFILE + this.SEPARATOR + this.APP + this.SEPARATOR + appType;

		return this.executeGET(url);
	}

	acceptUserTnC(tnc_profile_id: any): Promise<any> {

		var url = this.env.BASE_URL + Constants.ONBOARDING_URL +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.USER_TERMS_CONDITIONS_PROFILE + this.SEPARATOR + tnc_profile_id + this.SEPARATOR + this.ACCEPT;

		return this.executePUT(url, {}, this.authService.httpOption);
	}

	getPublishedVehicleProfilesToServicePackage(packageId) {
		var url = this.env.BASE_URL + this.SERVICEPACKAGE + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId +
			this.SEPARATOR + this.SERVICE + this.SEPARATOR + this.PACKAGE + this.SEPARATOR +
			packageId + this.SEPARATOR + this.BRANDS

		return this.executeGET(url);
	}

	getAccountVehicleBrands(): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId +
			this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.VEHICLES + this.SEPARATOR + this.BRANDS;

		return this.executeGET(url);
	}

	downloadPdf(attachmentUrl: string): Promise<any> {
		let httpOption = this.authService.httpOption;
		httpOption["responseType"] = 'blob' as 'json';

		return new Promise((resolve, reject) => {
			this.http.get(attachmentUrl, httpOption).subscribe((data) => {
				httpOption["responseType"] = 'json';
				resolve(data);
			},
				error => {
					httpOption["responseType"] = 'json';
					reject(error);
				});
		});
	}

	// Api call to fetch account packages during vehicle enrolment
	getAccountPackages(): Promise<any> {
		var url = this.env.BASE_URL + this.SERVICEPACKAGE + this.SEPARATOR +
			this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
			this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.SERVICE + this.PACKAGES;

		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				this.accountServicePackageList = data;
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getLocationsForMap(locationName, locationZip, locationId, locationCategory): Promise<any> {
		var url = this.env.BASE_URL + this.TELEMATICS + this.SEPARATOR + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + "/location/vehicles?fleetLocationCategory=" + locationCategory + "&fleetLocationId=" + locationId;
		return this.executeGET(url);
	}

	getDeviceSettings(): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + Constants.DEVICE + this.SEPARATOR + this.SETTINGS;
		return this.executeGET(url);
	}
	/* getPaginatedAccountDevices(payload, page, size): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR +
			this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR +
			this.authService.loggedInUser.accountId + this.SEPARATOR + this.VEHICLES + Constants.PAGINATED + Constants.FILTERS + encodeURIComponent("?page=" + page + "&pageSize=" + size);

		return this.executePOST(url, payload, this.authService.httpOption);
	} */

	getDevices(deviceType): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR +
			this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS +
			this.SEPARATOR + this.authService.loggedInUser.accountId + this.DEVICES + "?deviceType=" + deviceType;
		return this.executeGET(url);
	}

	getDeviceHistory(deviceId, vin): Promise<any> {
		if (vin) {
			var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR +
				this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS +
				this.SEPARATOR + this.authService.loggedInUser.accountId + this.DEVICES + this.SEPARATOR + deviceId + "?" + this.VIN + "=" + vin;
		} else {
			var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR +
				this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS +
				this.SEPARATOR + this.authService.loggedInUser.accountId + this.DEVICES + this.SEPARATOR + deviceId;
		}

		return this.executeGET(url);
	}

	getDeviceDetails(deviceId): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR +
			this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS +
			this.SEPARATOR + this.authService.loggedInUser.accountId + this.DEVICE + "?" + "deviceId" + "=" + deviceId;

		return this.executeGET(url);
	}
	/* getDeviceDetails(id): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + Constants.DEVICE + this.SEPARATOR + this.SETTINGS;
		// var url = this.env.BASE_URL + "/oem/5c63fe9f6245374925399620/accounts/61f38dbc6a514914d444cb8c/device?deviceId=6476fcc6a3b922591004b727";
		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(this.getDummyDeviceDetailsResponse()));

				resolve(res);
			},
				error => { reject(error); });
		});
	} */

	addDeviceToVehicle(payload, vin): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR +
		this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS +
		this.SEPARATOR + this.authService.loggedInUser.accountId +  this.SEPARATOR + this.VEHICLES +  this.SEPARATOR +  vin + this.DEVICES;

		return this.executePOST(url, payload, this.authService.httpOption);
	}
	/* addDeviceToVehicle(payload, vin): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR +
		this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS +
		this.SEPARATOR + this.authService.loggedInUser.accountId +  this.SEPARATOR + this.VEHICLES +  this.SEPARATOR +  vin + this.DEVICES;


		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + Constants.DEVICE + this.SEPARATOR + this.SETTINGS;
		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(this.getDummyaddDeviceToVehicleResponse()));

				resolve(res);
			},
				error => { reject(error); });
		});
	} */

	getAllSupportedLanguages(): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.SUPPORTED + this.SEPARATOR + this.LANGUAGES;

		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	updateLanguagePreference(payload, userId): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR + this.ACCOUNTS + this.SEPARATOR + this.authService.loggedInUser.accountId + this.SEPARATOR + this.USERS + this.SEPARATOR + userId + this.SEPARATOR + this.PREFERENCES + this.SEPARATOR;

		return this.executePOST(url, payload, this.authService.httpOption);
	}

	getDummyDeviceDetailsResponse() {
		return {
			"type": "DONGLE_DEVICE",
			"id": "6476fcc6a3b922591004b727",
			"deviceStatus": "INACTIVE",
			"telematicsType": "AFTER_MARKET",
			"telematicsProvider": "CONTINENTAL",
			"accountId": "61f38dbc6a514914d444cb8c",
			"vin": "3N1CN8EV1ML890652",
			"deviceSerialNumber": "ACCMb789680e0768ec8e",
			// "dongleStatus": "ENABLED"
			"dongleStatus": "DISABLED"
		};
	}

	getDummyaddDeviceToVehicleResponse() {
		return {
			"type": "DONGLE_DEVICE",
			"id": "6472073907d14f04c56edb4e",
			"deviceStatus": "INACTIVE",
			"telematicsType": "AFTER_MARKET",
			"telematicsProvider": "CONTINENTAL",
			"accountId": "623189b507d14f7020c27cae",
			"deviceSerialNumber": "ACCMb789680e0768ec8e",
			"dongleStatus": "ENABLED"
		};
	}

	getVehicleEvent(accountId, vin, page, pageSize): Promise<any> {
    var url = this.env.BASE_URL + "udrservice" + this.SEPARATOR +
    this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.SEPARATOR +
    this.ACCOUNTS + this.SEPARATOR + accountId + "/event/data/provisioning?page=" + page + "&pageSize=" + pageSize + "&vin=" + vin;

    return new Promise((resolve, reject) => {
      this.http.get(url, this.authService.httpOption).subscribe((data) => {
        var res = JSON.parse(JSON.stringify(data));
        console.log("response : ", res);
        resolve(res);
      },
        error => { reject(error); });
    });
  }

	getVehicles(): Promise<any> {
		var url = this.env.BASE_URL + "streaming/vehiclejourney/trips/vins";
		// var url = this.env.BASE_URL + this.LOCATIONMANAGEMENT + this.SEPARATOR +
		// 	this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.STATE +
		// 	this.SEPARATOR + "US";
		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				// var res = this.getDummyVehicles();
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getVehicleTrips(vin, pageIndex, pageSize): Promise<any> {
		var url = this.env.BASE_URL + "streaming/vehiclejourney/trips/alltrips/" + vin + "?offset=" + pageIndex + "&count=" + pageSize;;
		// var url = this.env.BASE_URL + this.LOCATIONMANAGEMENT + this.SEPARATOR +
		// 	this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.STATE +
		// 	this.SEPARATOR + "US";
		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				// var res = this.getDummyVehicleTrips(pageIndex, pageSize);
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getTripEvents(trip, pageIndex, pageSize): Promise<any> {
		var url = this.env.BASE_URL + "streaming/vehiclejourney/trips/tripdetails/" + trip + "?offset=" + pageIndex + "&count=" + pageSize;
		// var url = this.env.BASE_URL + this.LOCATIONMANAGEMENT + this.SEPARATOR +
		// this.OEM + this.SEPARATOR + this.authService.loggedInUser.enterpriseId + this.STATE +
		// this.SEPARATOR + "US";
		return new Promise((resolve, reject) => {
			this.http.get(url, this.authService.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				// var res = this.getDummyVehicleTripEvents(pageIndex, pageSize);
				console.log("response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	getDummyVehicles() {
		return ["1N6AA1E59RZ111549", "1N6AA1E57SZ111703", "1N6AA1E53RZ111448", "JN8AZ3AA9T9010002", "1N6AA1E57SZ111622", "1N6AA1ZZ3SZ111758", "1N6AA1E54SZ111755", "1N6AA1ZZ2SZ111752", "1N6AA1E59SZ111671", "1N6AA1E59RZ111552"];
	}

	getDummyVehicleTrips(offset, pageCount) {
		return {"tripsCount":1,"trips":["trips:1N6AA1E53RZ111448:2024-03-07T16:44:33.852Z"]};
		// console.log("Offset: ", offset, " - pageCount: ", pageCount, "eventCount: ", this.vehicleTrips.tripsCount);
		// var trips = JSON.parse(JSON.stringify(this.vehicleTrips));
		// // var tripData = null;
		// if (offset + pageCount >= this.vehicleTrips.tripsCount) {
		// 	pageCount = this.vehicleTrips.tripsCount - offset; // - 1;
		// 	console.log("PageCount: ", pageCount);
		// }
		// console.log("Sclicing trips with offset: ", offset, " pageCount: ", pageCount);
		// trips.trips = trips.trips.slice(offset, offset+pageCount);
		// return trips;
	}

	vehicleTrips = {
		"tripsCount": 22,
		"trips": [
			"1N6AA1ZZ3SZ111758:2024-03-07T01:43:50.39Z",
			"1N6AA1ZZ3SZ111758:2024-03-07T02:14:54.153Z",
			"1N6AA1ZZ3SZ111758:2024-03-07T03:43:50.39Z",
			"1N6AA1ZZ3SZ111758:2024-03-07T04:14:54.153Z",
			"1N6AA1ZZ3SZ111758:2024-03-07T05:43:50.39Z",
			"1N6AA1ZZ3SZ111758:2024-03-07T06:14:54.153Z",
			"1N6AA1ZZ3SZ111758:2024-03-07T07:43:50.39Z",
			"1N6AA1ZZ3SZ111758:2024-03-07T08:14:54.153Z",
			"1N6AA1ZZ3SZ111758:2024-03-07T09:43:50.39Z",
			"1N6AA1ZZ3SZ111758:2024-03-07T10:14:54.153Z",
			"1N6AA1ZZ3SZ111758:2024-03-07T11:43:50.39Z",
			"1N6AA1ZZ3SZ111758:2024-03-07T12:14:54.153Z",
			"1N6AA1ZZ3SZ111758:2024-03-07T13:43:50.39Z",
			"1N6AA1ZZ3SZ111758:2024-03-07T14:14:54.153Z",
			"1N6AA1ZZ3SZ111758:2024-03-07T15:43:50.39Z",
			"1N6AA1ZZ3SZ111758:2024-03-07T16:14:54.153Z",
			"1N6AA1ZZ3SZ111758:2024-03-07T17:43:50.39Z",
			"1N6AA1ZZ3SZ111758:2024-03-07T18:14:54.153Z",
			"1N6AA1ZZ3SZ111758:2024-03-07T19:43:50.39Z",
			"1N6AA1ZZ3SZ111758:2024-03-07T20:14:54.153Z",
			"1N6AA1ZZ3SZ111758:2024-03-07T21:43:50.39Z",
			"1N6AA1ZZ3SZ111758:2024-03-07T22:14:54.153Z"
		]
	};

	getDummyVehicleTripEvents(offset, pageCount) {
		return { "eventsCount": 70, "events": [{ "EventPublishedAt": "2025-03-19T19:05:40.201Z", "EventReceivedAt": "2025-03-19T19:05:40.200Z", "EventReceived": { "bin": "00000000000000000000000000000000", "EventArrivalTimeStamp": "2024-03-08T02:32:37Z", "Data": { "HistoricalCellTension1": null, "CellVoltageMin": null, "HistoricalCellTension5": null, "HistoricalCellTension4": null, "HistoricalCellTension3": null, "WindowsRearRightPosition": 1, "HistoricalCellTension2": null, "StatusVehicleStates": 7, "LocationLatitude": 42.49434048, "CrashAirbagPassengerInhibition": null, "HistoricalCellTension9": null, "HistoricalCellTension8": null, "HVACTemperatureCabinCurrentValue": 0, "HistoricalCellTension7": null, "HistoricalCellTension6": null, "DoorsRearLeftLocked": 0, "TriggerType": "UCD/Sent/Trigger/Trg_IGN_ON_Probe_DriverInfoPermit", "HistoricalCellTension11": null, "HistoricalCellTension12": null, "HistoricalCellTension10": null, "HistoricalCellTension15": null, "HistoricalCellTension16": null, "HistoricalCellTension13": null, "HistoricalCellTension14": null, "WindowsFrontLeftPosition": 1, "HistoricalCellTension19": null, "TimeStamp": "2024-03-07T21:14:51.498Z", "HistoricalCellTension17": null, "HistoricalCellTension18": null, "VehicleReceivedHEVAutonomyDisplay": null, "SuspensionSettingState": 0, "VehicleReceivedEV_HVBatteryTemperatureMaxTempProbe": null, "DoorsBackLocked": 0, "SeatBeltThirdRowRight": 0, "StatusWheelStateFrontRight": 0, "SeatBeltSecondRowLeft": 3, "WindowsRearLeftPosition": 1, "EngineWaterTempWarning": 0, "HV_BatteryLowestCellVoltageProbeID": null, "DistanceToPrecedingVehicle": 0, "LocationHeading": 0, "DoorsDriverLocked": 0, "StatusDoorOutsideLockedState": 0, "LocationLongitude": -83.42391731, "ECMatmosphericPressure": null, "ESCAccelerationTransversalCorrected": 0.017000000923872, "ExternalTempValue": -50, "SeatBeltSecondRowCenter": 3, "LaneDepartureWarningRequest": 0, "StatusDistanceTotalizer": 7213.52978515625, "ESCAccelerationLongitudinalCorrected": null, "BrakeLampStatus": 1, "SeatBeltFirstRowDriver": 1, "ChargeStatus": null, "UCDVersion": "05.05.10.09", "WheelPressurestateRearLeft": 1, "StatusWheelStateFrontLeft": 0, "FuelConsumptionDistanceToEmptyTank": 135, "StatusWheelPressureRearLeft": null, "SeatBeltThirdRowCenter": 0, "HistoricalCellTension84": null, "HistoricalCellTension85": null, "HistoricalCellTension82": null, "HistoricalCellTension83": null, "HistoricalCellTension88": null, "HistoricalCellTension89": null, "HistoricalCellTension86": null, "HistoricalCellTension87": null, "StatusWheelStateRearRight": 0, "LightningLowBeam": 0, "HVBatteryMaxCapacity": null, "StatusDoorPassenger": 1, "SeatBeltFirstRowCenter": 0, "StatusWheelStateRearLeft": 0, "HistoricalCellTension91": null, "HistoricalCellTension92": null, "HistoricalCellTension90": null, "HistoricalCellTension95": null, "HistoricalCellTension96": null, "WindowsFrontRightPosition": 1, "HistoricalCellTension93": null, "HistoricalCellTension94": null, "DoorsPassengerLocked": 0, "AirTempStartingTimeValue": null, "SeatBeltThirdRowLeft": 0, "StatusWheelPressureFrontRight": null, "HistoricalCellTension62": null, "HistoricalCellTension63": null, "HistoricalCellTension60": null, "HistoricalCellTension61": null, "VehicleReceivedEV_HVBatteryTemperatureMinTempProbe": null, "HistoricalCellTension66": null, "HistoricalCellTension67": null, "HistoricalCellTension64": null, "HistoricalCellTension65": null, "BCM_PositionDriverSide": 0, "HistoricalCellTension68": null, "EV_AvailableEnergy": null, "HistoricalCellTension69": null, "VehicleSteeringAngle": -0.100000001490116, "LastKnownlocationaltitude": 258, "DoorsRearRightLocked": 0, "AirTempStartingTimeUnit": 1, "HistoricalCellTension70": null, "HistoricalCellTension73": null, "HistoricalCellTension74": null, "HistoricalCellTension71": null, "HistoricalCellTension72": null, "HistoricalCellTension77": null, "HistoricalCellTension78": null, "WheelPressurestateFrontRight": 1, "HistoricalCellTension75": null, "HistoricalCellTension76": null, "OilLevel": 0, "HistoricalCellTension79": null, "StatusIgnitionSwitchPosition": 0, "WheelPressurestateRearRight": 1, "GearBoxAutomaticRangeIndication": 1, "HistoricalCellTension80": null, "HistoricalCellTension81": null, "CellVoltageMax": null, "HistoricalCellTension40": null, "SeatBeltFirstRowPassenger": 3, "HistoricalCellTension41": null, "HistoricalCellTension44": null, "HistoricalCellTension45": null, "HistoricalCellTension42": null, "HistoricalCellTension43": null, "HistoricalCellTension48": null, "HistoricalCellTension49": null, "HistoricalCellTension46": null, "HistoricalCellTension47": null, "VehicleReceivedEV_HVBatteryTemperatureProbe_16": null, "VehicleReceivedEV_HVBatteryTemperatureProbe_17": null, "VehicleReceivedEV_HVBatteryTemperatureProbe_14": null, "VehicleReceivedEV_HVBatteryTemperatureProbe_15": null, "VehicleReceivedEV_HVBatteryTemperatureProbe_18": null, "VehicleReceivedEV_HVBatteryTemperatureProbe_19": null, "VehicleReceivedEV_HVBatteryTemperatureProbe_12": null, "VehicleReceivedEV_HVBatteryTemperatureProbe_13": null, "VehicleReceivedEV_HVBatteryTemperatureProbe_10": null, "VehicleReceivedEV_HVBatteryTemperatureProbe_11": null, "HistoricalCellTension51": null, "LightningHighBeam": 0, "HistoricalCellTension52": null, "HistoricalCellTension50": null, "HistoricalCellTension55": null, "HistoricalCellTension56": null, "HistoricalCellTension53": null, "HistoricalCellTension54": null, "HistoricalCellTension59": null, "HistoricalCellTension57": null, "HistoricalCellTension58": null, "ZEVAutonomyDisplay": 0, "SeatBeltSecondRowRight": 3, "VehicleReceivedEV_HVBatteryTemperatureProbe_05": null, "LocationSource": 0, "VehicleReceivedEV_HVBatteryTemperatureProbe_06": null, "VehicleReceivedEV_HVBatteryTemperatureProbe_03": null, "VehicleReceivedEV_HVBatteryTemperatureProbe_04": null, "VehicleReceivedEV_HVBatteryTemperatureProbe_09": null, "VehicleReceivedEV_HVBatteryTemperatureProbe_07": null, "StatusWheelPressureFrontLeft": null, "VehicleReceivedEV_HVBatteryTemperatureProbe_08": null, "VehicleReceivedEV_HVBatteryTemperatureProbe_01": null, "VehicleReceivedEV_HVBatteryTemperatureProbe_02": null, "WheelPressurestateFrontLeft": 1, "HistoricalCellTension22": null, "HistoricalCellTension23": null, "HistoricalCellTension20": null, "HistoricalCellTension21": null, "HistoricalCellTension26": null, "HistoricalCellTension27": null, "HistoricalCellTension24": null, "HistoricalCellTension25": null, "HistoricalCellTension28": null, "HistoricalCellTension29": null, "UserID": "Anonymous", "GEEBatteryVoltage": 10.9200000762939, "HistoricalCellTension30": null, "HistoricalCellTension33": null, "HistoricalCellTension34": null, "HistoricalCellTension31": null, "HistoricalCellTension32": null, "HistoricalCellTension37": null, "HistoricalCellTension38": null, "HistoricalCellTension35": null, "HistoricalCellTension36": null, "HistoricalCellTension39": null, "StatusWheelPressureRearRight": null, "ESCABSMalfunction": 0, "WipingFrontDuration": 0, "VehicleReceivedEV_HVBatteryTemperatureProbe_20": null, "EngineAirTemperature": 8 }, "TargetId": "Telemetry", "TimeStamp": "2024-03-07T21:14:54.153Z", "DeviceType": "A-IVCKAIEVO", "DataDictionaryVersion": "0.2.35", "DCMVersion": "1.6.15.0", "VIN": "1N6AA1ZZ3SZ111758", "CorrelationId": "e0e00642-aa4c-4994-b2e2-ea1b677c9970", "Id": "e0e00642-aa4c-4994-b2e2-ea1b677c9970", "DevId": "VA2C312UEGT232300478", "MessageType": "UCD_Snapshot" } }] };
		// console.log("Offset: ", offset, " - pageCount: ", pageCount, "eventCount: ", this.vehicleTripsEevents.eventsCount);
		// var trips = JSON.parse(JSON.stringify(this.vehicleTripsEevents));
		// // var tripData = null;
		// if (offset + pageCount >= this.vehicleTripsEevents.eventsCount) {
		// 	pageCount = this.vehicleTripsEevents.eventsCount - offset; // - 1;
		// 	console.log("PageCount: ", pageCount);
		// }
		// console.log("Sclicing trips with offset: ", offset, " pageCount: ", pageCount);
		// trips.events = trips.events.slice(offset, offset+pageCount);
		// return trips;
	}

	vehicleTripsEevents = {
		"eventsCount": 11,
		"events": [
			{
				"EventPublishedAt": "01-2024-04-11T12:37:24.381Z",
				"EventReceivedAt": "2024-04-11T12:37:24.379Z",
				"EventReceived": {
					"bin": "00000000000000000000000000000000",
					"EventArrivalTimeStamp": "2024-03-08T02:32:41Z",
					"Data": {
						"TriggerType": "Vehicle/Trigger/EndOfJourney",
						"UCDVersion": "05.05.10.09",
						"TimeStamp": "2024-03-07T21:16:18.347Z",
						"EVHVBatteryEnergyLevel": null
					},
					"TargetId": "Telemetry",
					"TimeStamp": "2024-03-07T21:16:21.584Z",
					"DeviceType": "A-IVCKAIEVO",
					"DataDictionaryVersion": "0.2.35",
					"DCMVersion": "1.6.15.0",
					"VIN": "1N6AA1ZZ3SZ111758",
					"CorrelationId": "bb220bb8-b8ba-45f5-b9cc-1426ec24f5dc",
					"Id": "bb220bb8-b8ba-45f5-b9cc-1426ec24f5dc",
					"DevId": "VA2C312UEGT232300478",
					"MessageType": "UCD_Snapshot"
				}
			},
			{
				"EventPublishedAt": "02-2024-04-11T12:37:24.381Z",
				"EventReceivedAt": "2024-04-11T12:37:24.379Z",
				"EventReceived": {
					"bin": "00000000000000000000000000000000",
					"EventArrivalTimeStamp": "2024-03-08T02:32:41Z",
					"Data": {
						"TriggerType": "Vehicle/Trigger/EndOfJourney",
						"UCDVersion": "05.05.10.09",
						"TimeStamp": "2024-03-07T21:16:18.347Z",
						"EVHVBatteryEnergyLevel": null
					},
					"TargetId": "Telemetry",
					"TimeStamp": "2024-03-07T21:16:21.584Z",
					"DeviceType": "A-IVCKAIEVO",
					"DataDictionaryVersion": "0.2.35",
					"DCMVersion": "1.6.15.0",
					"VIN": "1N6AA1ZZ3SZ111758",
					"CorrelationId": "bb220bb8-b8ba-45f5-b9cc-1426ec24f5dc",
					"Id": "bb220bb8-b8ba-45f5-b9cc-1426ec24f5dc",
					"DevId": "VA2C312UEGT232300478",
					"MessageType": "UCD_Snapshot"
				}
			},
			{
				"EventPublishedAt": "03-2024-04-11T12:37:24.381Z",
				"EventReceivedAt": "2024-04-11T12:37:24.379Z",
				"EventReceived": {
					"bin": "00000000000000000000000000000000",
					"EventArrivalTimeStamp": "2024-03-08T02:32:41Z",
					"Data": {
						"TriggerType": "Vehicle/Trigger/EndOfJourney",
						"UCDVersion": "05.05.10.09",
						"TimeStamp": "2024-03-07T21:16:18.347Z",
						"EVHVBatteryEnergyLevel": null
					},
					"TargetId": "Telemetry",
					"TimeStamp": "2024-03-07T21:16:21.584Z",
					"DeviceType": "A-IVCKAIEVO",
					"DataDictionaryVersion": "0.2.35",
					"DCMVersion": "1.6.15.0",
					"VIN": "1N6AA1ZZ3SZ111758",
					"CorrelationId": "bb220bb8-b8ba-45f5-b9cc-1426ec24f5dc",
					"Id": "bb220bb8-b8ba-45f5-b9cc-1426ec24f5dc",
					"DevId": "VA2C312UEGT232300478",
					"MessageType": "UCD_Snapshot"
				}
			},
			{
				"EventPublishedAt": "04-2024-04-11T12:37:24.381Z",
				"EventReceivedAt": "2024-04-11T12:37:24.379Z",
				"EventReceived": {
					"bin": "00000000000000000000000000000000",
					"EventArrivalTimeStamp": "2024-03-08T02:32:41Z",
					"Data": {
						"TriggerType": "Vehicle/Trigger/EndOfJourney",
						"UCDVersion": "05.05.10.09",
						"TimeStamp": "2024-03-07T21:16:18.347Z",
						"EVHVBatteryEnergyLevel": null
					},
					"TargetId": "Telemetry",
					"TimeStamp": "2024-03-07T21:16:21.584Z",
					"DeviceType": "A-IVCKAIEVO",
					"DataDictionaryVersion": "0.2.35",
					"DCMVersion": "1.6.15.0",
					"VIN": "1N6AA1ZZ3SZ111758",
					"CorrelationId": "bb220bb8-b8ba-45f5-b9cc-1426ec24f5dc",
					"Id": "bb220bb8-b8ba-45f5-b9cc-1426ec24f5dc",
					"DevId": "VA2C312UEGT232300478",
					"MessageType": "UCD_Snapshot"
				}
			},
			{
				"EventPublishedAt": "05-2024-04-11T12:37:24.381Z",
				"EventReceivedAt": "2024-04-11T12:37:24.379Z",
				"EventReceived": {
					"bin": "00000000000000000000000000000000",
					"EventArrivalTimeStamp": "2024-03-08T02:32:41Z",
					"Data": {
						"TriggerType": "Vehicle/Trigger/EndOfJourney",
						"UCDVersion": "05.05.10.09",
						"TimeStamp": "2024-03-07T21:16:18.347Z",
						"EVHVBatteryEnergyLevel": null
					},
					"TargetId": "Telemetry",
					"TimeStamp": "2024-03-07T21:16:21.584Z",
					"DeviceType": "A-IVCKAIEVO",
					"DataDictionaryVersion": "0.2.35",
					"DCMVersion": "1.6.15.0",
					"VIN": "1N6AA1ZZ3SZ111758",
					"CorrelationId": "bb220bb8-b8ba-45f5-b9cc-1426ec24f5dc",
					"Id": "bb220bb8-b8ba-45f5-b9cc-1426ec24f5dc",
					"DevId": "VA2C312UEGT232300478",
					"MessageType": "UCD_Snapshot"
				}
			},
			{
				"EventPublishedAt": "06-2024-04-11T12:37:24.381Z",
				"EventReceivedAt": "2024-04-11T12:37:24.379Z",
				"EventReceived": {
					"bin": "00000000000000000000000000000000",
					"EventArrivalTimeStamp": "2024-03-08T02:32:41Z",
					"Data": {
						"TriggerType": "Vehicle/Trigger/EndOfJourney",
						"UCDVersion": "05.05.10.09",
						"TimeStamp": "2024-03-07T21:16:18.347Z",
						"EVHVBatteryEnergyLevel": null
					},
					"TargetId": "Telemetry",
					"TimeStamp": "2024-03-07T21:16:21.584Z",
					"DeviceType": "A-IVCKAIEVO",
					"DataDictionaryVersion": "0.2.35",
					"DCMVersion": "1.6.15.0",
					"VIN": "1N6AA1ZZ3SZ111758",
					"CorrelationId": "bb220bb8-b8ba-45f5-b9cc-1426ec24f5dc",
					"Id": "bb220bb8-b8ba-45f5-b9cc-1426ec24f5dc",
					"DevId": "VA2C312UEGT232300478",
					"MessageType": "UCD_Snapshot"
				}
			},
			{
				"EventPublishedAt": "07-2024-04-11T12:37:24.381Z",
				"EventReceivedAt": "2024-04-11T12:37:24.379Z",
				"EventReceived": {
					"bin": "00000000000000000000000000000000",
					"EventArrivalTimeStamp": "2024-03-08T02:32:41Z",
					"Data": {
						"TriggerType": "Vehicle/Trigger/EndOfJourney",
						"UCDVersion": "05.05.10.09",
						"TimeStamp": "2024-03-07T21:16:18.347Z",
						"EVHVBatteryEnergyLevel": null
					},
					"TargetId": "Telemetry",
					"TimeStamp": "2024-03-07T21:16:21.584Z",
					"DeviceType": "A-IVCKAIEVO",
					"DataDictionaryVersion": "0.2.35",
					"DCMVersion": "1.6.15.0",
					"VIN": "1N6AA1ZZ3SZ111758",
					"CorrelationId": "bb220bb8-b8ba-45f5-b9cc-1426ec24f5dc",
					"Id": "bb220bb8-b8ba-45f5-b9cc-1426ec24f5dc",
					"DevId": "VA2C312UEGT232300478",
					"MessageType": "UCD_Snapshot"
				}
			},
			{
				"EventPublishedAt": "08-2024-04-11T12:37:24.381Z",
				"EventReceivedAt": "2024-04-11T12:37:24.379Z",
				"EventReceived": {
					"bin": "00000000000000000000000000000000",
					"EventArrivalTimeStamp": "2024-03-08T02:32:41Z",
					"Data": {
						"TriggerType": "Vehicle/Trigger/EndOfJourney",
						"UCDVersion": "05.05.10.09",
						"TimeStamp": "2024-03-07T21:16:18.347Z",
						"EVHVBatteryEnergyLevel": null
					},
					"TargetId": "Telemetry",
					"TimeStamp": "2024-03-07T21:16:21.584Z",
					"DeviceType": "A-IVCKAIEVO",
					"DataDictionaryVersion": "0.2.35",
					"DCMVersion": "1.6.15.0",
					"VIN": "1N6AA1ZZ3SZ111758",
					"CorrelationId": "bb220bb8-b8ba-45f5-b9cc-1426ec24f5dc",
					"Id": "bb220bb8-b8ba-45f5-b9cc-1426ec24f5dc",
					"DevId": "VA2C312UEGT232300478",
					"MessageType": "UCD_Snapshot"
				}
			},
			{
				"EventPublishedAt": "09-2024-04-11T12:37:24.381Z",
				"EventReceivedAt": "2024-04-11T12:37:24.379Z",
				"EventReceived": {
					"bin": "00000000000000000000000000000000",
					"EventArrivalTimeStamp": "2024-03-08T02:32:41Z",
					"Data": {
						"TriggerType": "Vehicle/Trigger/EndOfJourney",
						"UCDVersion": "05.05.10.09",
						"TimeStamp": "2024-03-07T21:16:18.347Z",
						"EVHVBatteryEnergyLevel": null
					},
					"TargetId": "Telemetry",
					"TimeStamp": "2024-03-07T21:16:21.584Z",
					"DeviceType": "A-IVCKAIEVO",
					"DataDictionaryVersion": "0.2.35",
					"DCMVersion": "1.6.15.0",
					"VIN": "1N6AA1ZZ3SZ111758",
					"CorrelationId": "bb220bb8-b8ba-45f5-b9cc-1426ec24f5dc",
					"Id": "bb220bb8-b8ba-45f5-b9cc-1426ec24f5dc",
					"DevId": "VA2C312UEGT232300478",
					"MessageType": "UCD_Snapshot"
				}
			},
			{
				"EventPublishedAt": "10-2024-04-11T12:37:24.381Z",
				"EventReceivedAt": "2024-04-11T12:37:24.379Z",
				"EventReceived": {
					"bin": "00000000000000000000000000000000",
					"EventArrivalTimeStamp": "2024-03-08T02:32:41Z",
					"Data": {
						"TriggerType": "Vehicle/Trigger/EndOfJourney",
						"UCDVersion": "05.05.10.09",
						"TimeStamp": "2024-03-07T21:16:18.347Z",
						"EVHVBatteryEnergyLevel": null
					},
					"TargetId": "Telemetry",
					"TimeStamp": "2024-03-07T21:16:21.584Z",
					"DeviceType": "A-IVCKAIEVO",
					"DataDictionaryVersion": "0.2.35",
					"DCMVersion": "1.6.15.0",
					"VIN": "1N6AA1ZZ3SZ111758",
					"CorrelationId": "bb220bb8-b8ba-45f5-b9cc-1426ec24f5dc",
					"Id": "bb220bb8-b8ba-45f5-b9cc-1426ec24f5dc",
					"DevId": "VA2C312UEGT232300478",
					"MessageType": "UCD_Snapshot"
				}
			},
			{
				"EventPublishedAt": "11-2024-04-11T12:37:24.381Z",
				"EventReceivedAt": "2024-04-11T12:37:24.379Z",
				"EventReceived": {
					"bin": "00000000000000000000000000000000",
					"EventArrivalTimeStamp": "2024-03-08T02:32:41Z",
					"Data": {
						"TriggerType": "Vehicle/Trigger/EndOfJourney",
						"UCDVersion": "05.05.10.09",
						"TimeStamp": "2024-03-07T21:16:18.347Z",
						"EVHVBatteryEnergyLevel": null
					},
					"TargetId": "Telemetry",
					"TimeStamp": "2024-03-07T21:16:21.584Z",
					"DeviceType": "A-IVCKAIEVO",
					"DataDictionaryVersion": "0.2.35",
					"DCMVersion": "1.6.15.0",
					"VIN": "1N6AA1ZZ3SZ111758",
					"CorrelationId": "bb220bb8-b8ba-45f5-b9cc-1426ec24f5dc",
					"Id": "bb220bb8-b8ba-45f5-b9cc-1426ec24f5dc",
					"DevId": "VA2C312UEGT232300478",
					"MessageType": "UCD_Snapshot"
				}
			}
		]
	};
}